<div class="snack-bar-content">
  <emperor-icon name="interface_information"></emperor-icon>
  <span> {{ data.message }}</span>
</div>
<div class="snack-bar-action" *ngIf="hasAction">
  <button mat-button (click)="action()">{{ data.action }}</button>
</div>
